/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Approval_Passed_LabelInputs */

const en_style_guide_manager_approval_passed_label = /** @type {(inputs: Style_Guide_Manager_Approval_Passed_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approval Passed`)
};

const fr_style_guide_manager_approval_passed_label = /** @type {(inputs: Style_Guide_Manager_Approval_Passed_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approbation reussie`)
};

const de_style_guide_manager_approval_passed_label = /** @type {(inputs: Style_Guide_Manager_Approval_Passed_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genehmigung erteilt`)
};

const it_style_guide_manager_approval_passed_label = /** @type {(inputs: Style_Guide_Manager_Approval_Passed_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approvazione superata`)
};

const ru_style_guide_manager_approval_passed_label = /** @type {(inputs: Style_Guide_Manager_Approval_Passed_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Одобрение получено.`)
};

const es_style_guide_manager_approval_passed_label = /** @type {(inputs: Style_Guide_Manager_Approval_Passed_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprobación aprobada`)
};

const zh_cn2_style_guide_manager_approval_passed_label = /** @type {(inputs: Style_Guide_Manager_Approval_Passed_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已批准`)
};

const ja_style_guide_manager_approval_passed_label = /** @type {(inputs: Style_Guide_Manager_Approval_Passed_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`承認が通過しました`)
};

const hi_style_guide_manager_approval_passed_label = /** @type {(inputs: Style_Guide_Manager_Approval_Passed_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनुमोदन पारित हो गया`)
};

const pt_pt2_style_guide_manager_approval_passed_label = /** @type {(inputs: Style_Guide_Manager_Approval_Passed_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprovação concedida.`)
};

/**
* | output |
* | --- |
* | "Approval Passed" |
*
* @param {Style_Guide_Manager_Approval_Passed_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_approval_passed_label = /** @type {((inputs?: Style_Guide_Manager_Approval_Passed_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Approval_Passed_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_approval_passed_label(inputs)
	if (locale === "de") return de_style_guide_manager_approval_passed_label(inputs)
	if (locale === "it") return it_style_guide_manager_approval_passed_label(inputs)
	if (locale === "ru") return ru_style_guide_manager_approval_passed_label(inputs)
	if (locale === "es") return es_style_guide_manager_approval_passed_label(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_approval_passed_label(inputs)
	if (locale === "ja") return ja_style_guide_manager_approval_passed_label(inputs)
	if (locale === "hi") return hi_style_guide_manager_approval_passed_label(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_approval_passed_label(inputs)
	return en_style_guide_manager_approval_passed_label(inputs)
});